module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadControl', {
    ref: "headControl",
    attrs: {
      "titleName": '派单数据'
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    ref: "sendOrdersNum",
    staticClass: "sendOrdersNum"
  }), _vm._v(" "), _c('span', {
    staticClass: "sendNum"
  }, [_vm._v("\n        派单总数:"), _c('span', [_c('span', {
    staticClass: "num"
  }, [_vm._v(" " + _vm._s(_vm.count))]), _vm._v("个")])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "b_left"
  }, [_c('div', {
    staticClass: "projectArea"
  }, [_c('div', {
    staticClass: "p_title"
  }, [_vm._v("项目地区")]), _vm._v(" "), _c('div', {
    staticClass: "areaWrap"
  }, _vm._l((_vm.projectAreaData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "location"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "number"
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.count))]), _vm._v("个")])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "residentWrap"
  }, [_c('div', {
    ref: "residentPer",
    staticClass: "residentPer"
  }), _vm._v(" "), _vm._l((_vm.residentNumList), function(item, index) {
    return _c('div', {
      key: index + 2,
      staticClass: "leftTitle",
      class: {
        'lastTitle': index == 1
      }
    }, [_vm._v("驻场(" + _vm._s(item) + "个)")])
  }), _vm._v(" "), _vm._l((_vm.notResidentNumList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "rightTitle"
    }, [_vm._v("不驻场(" + _vm._s(item) + "个)")])
  })], 2)]), _vm._v(" "), _c('div', {
    ref: "projectGrade",
    staticClass: "projectGrade"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-246c3aa2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/engineeringData/sendOrdersData.vue
// module id = 1652
// module chunks = 471